import { Injectable } from '@angular/core';
import { Uuid } from '../domain/model/uuid/uuid.type';
import { XRegUuid } from '../domain/model/uuid/xreg-uuid';

@Injectable({
  providedIn: 'root',
})
export class UuidService {
  getNewUuid(): Uuid {
    return new XRegUuid();
  }
}
